'use strict';

var index = require('../../gestures/drag/index.cjs');
var index$1 = require('../../gestures/pan/index.cjs');
var MeasureLayout = require('./layout/MeasureLayout.cjs');
var HTMLProjectionNode = require('../../projection/node/HTMLProjectionNode.cjs');

const drag = {
    pan: {
        Feature: index$1.PanGesture,
    },
    drag: {
        Feature: index.DragGesture,
        ProjectionNode: HTMLProjectionNode.HTMLProjectionNode,
        MeasureLayout: MeasureLayout.MeasureLayout,
    },
};

exports.drag = drag;
//# sourceMappingURL=drag.cjs.map
